import { IIconProps } from "~/types";
const LinkIcon = (props:IIconProps) => (
  <svg
    width={18}
    height={18}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.371 7.629a3 3 0 0 0-4.242 0l-3 3A3 3 0 1 0 7.37 14.87l.826-.826m-.568-3.674a3 3 0 0 0 4.242 0l3-3a3 3 0 1 0-4.24-4.24l-.825.824"
      stroke="#2C3556"
      strokeWidth={1.25}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default LinkIcon;
